import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactDOM from 'react-dom';
import GoldenLayout from 'golden-layout';
import $ from 'jquery';
import 'golden-layout/src/css/goldenlayout-base.css';
import 'golden-layout/src/css/goldenlayout-light-theme.css';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { isEqual } from 'lodash';
import withRouter from '@/routes/withRouter';
import urls, { pathsMatch, relativeUrl, relativeUrls } from '@/constants/urls';
import { decodeSearchQuery } from '@/search/actions';
import { tabConfig } from '../state/state';
import Panels, {
  findTabByUrl,
  onTabAddIcon,
  customiseHeader,
  tabsList,
  comparePanels,
  compareTabs,
} from '../layoutManagerTabs';
import WrappedTab from '../components/WrappedTab';
import { containerShell } from '../constants';
import closePanel, { closeMultiplePanels } from '../layoutManagerPanelCloser';
import {
  layoutKey,
  defaultLayout,
  developerConfig,
  layoutSettings,
  includesComponent,
  rowStack,
  stackIsDirty,
  componentIsDirty,
  setTabTitle,
  setPageTitle,
  checkTabChanges,
  transformLayout,
} from '../layoutManagerHelper';
import TabsDropDown from '../components/TabsDropDown';
import {
  updateActions, updateFullscreen, updateTabs, updateTitle,
} from '../actions';
import listener from '../goldenLayoutListener';
import ReactComponentHandlerPatched from '../goldenLayoutPatch';

/* eslint no-underscore-dangle: ["error", { "allow": ["_getReactComponent", "_container", "__lm", "_config"] }] */
/* eslint max-classes-per-file: ["error", 2] */
/* eslint camelcase: ["error", {allow: ["UNSAFE_componentWillReceiveProps"]}] */
class LayoutManager extends React.Component {
  constructor(props) {
    super(props);
    this.layout = undefined;
    this.baseUrl = '/data';
    this.state = {
      overridingTabClick: false,
      activeUrl: this.baseUrl,
    };
    this.configureRefs();
    this.bindToThis();
    this.listenTo();

    $(document).ready(this.renderLayout);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props;
    const currentPathname = location.pathname === '/' ? relativeUrl(urls.HOME) : location.pathname;
    const nextPathname = nextProps.location.pathname;

    if (!pathsMatch(currentPathname, nextPathname)) {
      this.findorCreatePanel(nextPathname);
    }
  }

  onCloseTabs(itemUrls) {
    const components = this.rootContentItem().getItemsByFilter(
      (item) => includesComponent(item, itemUrls, true),
    );
    components.forEach((component) => this.closeTab(component, false));
  }

  onActionNavigate(action) {
    if (action.previousUrl) {
      this.updateComponentState({ ...action, title: action.name }, action.previousUrl);
      this.saveStateAsync().then();
    }
    this.navigateToUrl(action.url).then();
  }

  onContainerShow(component) {
    const { ignoreTabState } = this.state;
    if (!ignoreTabState && component.parent.isStack) {
      const { overridingTabClick } = this.state;
      this.navigateToComponent(component, !overridingTabClick);
    }
  }

  onItemDestroyed(component) {
    if (component.isStack) {
      this.onStackDestroyed(component);
    } else if (component.isComponent
      && component.parent.contentItems.length <= 1
      && component.parent === this.activeStack()) {
      this.selectOnClose(component);
    }
  }

  onStackDestroyed(stack) {
    const stacks = this.allStacks();
    if (stacks.length === 2) {
      const index = stacks.indexOf(stack);
      if (index !== -1) {
        stacks.splice(index, 1);
      }
      this.selectStack(stacks[0]);
    } else if (stacks.length <= 1) {
      this.notifyPanelChange();
      this.navigateToUrl('/').then();
    }
  }

  async onPanelContentClick(element) {
    const id = $(element.currentTarget).closest('.panel-no-focus').length >= 1
      ? null
      : $(element.currentTarget).find('div.panel-identifier').attr('id');

    if (id) {
      this.activateStackById(id);
    }
  }

  onSelectionChanged() {
    const { overridingTabClick } = this.state;
    if (!overridingTabClick) {
      const panel = this.ensureActivePanel();
      if (panel) {
        this.navigateToComponent(panel, true);
      }
    }
  }

  onStackClose(stack) {
    stack.header.controlsContainer.find('.lm_close')
      .off('click').click(() => {
        this.closeStack(stack, true);
      });
  }

  onStackCreated(stack) {
    this.addFullScreen(stack);
    this.onStackClose(stack);
    this.onStackMax(stack);
  }

  onStackMax(stack) {
    stack.header.controlsContainer.find('.lm_maximise')
      .off('click').click(() => {
        this.toggleMax(stack, !stack.isMaximised);
        if (stack.isMaximised) { this.selectStackAsync(stack).then(); }
      });
  }

  async onTabClick(element) {
    const id = $(element.currentTarget).closest('div.lm_stack').find('div.panel-identifier').attr('id');
    if (id) { this.activateStackById(id); }
  }

  onTabClose(tab) {
    tab.closeElement.off('click').click(() => { this.closeTab(tab.contentItem, true); });
  }

  oneTabOnly() {
    const { fullscreen, layout } = this.layoutState();
    return fullscreen || layout === 'focus';
  }

  getItemsByType(type) {
    if (!this.hasRootContentItem()) { return null; }
    return this.rootContentItem().getItemsByType(type);
  }

  activateStackById(id) {
    const stack = this.allStacks().find((item) => item.element.find(`#${id}`)[0]);
    if (stack) {
      this.navigateToComponent(stack.getActiveContentItem(), true);
    }
  }

  activePanel() {
    const stack = this.activeStack();
    return stack ? stack.getActiveContentItem() : null;
  }

  activeStack() {
    return (this.hasRootContentItem() && this.layout.selectedItem && this.layout.selectedItem.isStack)
      ? this.layout.selectedItem : null;
  }

  addChild(tab) {
    const stack = this.oneTabOnly()
      ? this.ensureActiveStack()
      : this.firstStack();

    if (stack) {
      this.selectStack(stack);
      stack.addChild(tab);
    } else {
      this.addEmptyStack(tab);
    }

    const component = this.matchByTabUrl(tab);
    this.configureSingleTabLayout();
    customiseHeader(component, true);

    return component;
  }

  addEmptyStack(tab) {
    const stack = rowStack(tab);
    this.layout.root.addChild(stack);

    return stack;
  }

  addFullScreen(stack) {
    const { intl } = this.props;
    const title = intl.formatMessage({ id: 'ribbon.layout.full' });
    const button = `<li class="fas fa-expand full_screen" title="${title}"></li>`;
    stack.header.controlsContainer.prepend(button);

    stack.header.controlsContainer.find('.full_screen').click(() => {
      this.toggleFullscreen(stack);
    });
  }

  allComponents() {
    return this.getItemsByType('component') || [];
  }

  allStacks() {
    const stacks = this.getItemsByType('stack');

    if (stacks && stacks.length === 0) {
      const component = this.firstComponent();
      if (component && component.parent.isStack) {
        stacks.push(component.parent);
      }
    }

    return stacks;
  }

  applyFakeTabTitle(panel, components) {
    const { applyTabsToDropDown, changeTitle } = this.props;
    const { tabs } = this.layoutState();
    const items = components || this.allComponents();
    const sortedTabs = tabsList(panel, items).sort(compareTabs);

    if (!isEqual(sortedTabs, tabs)) {
      setPageTitle(changeTitle, panel);
      applyTabsToDropDown(sortedTabs);
    }
  }

  bindToThis() {
    this.postRenderIDE = this.postRenderIDE.bind(this);
    this.renderLayout = this.renderLayout.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onStackCreated = this.onStackCreated.bind(this);
    this.onTabClose = this.onTabClose.bind(this);
    this.onStackClose = this.onStackClose.bind(this);
    this.onContainerShow = this.onContainerShow.bind(this);
    this.onItemDestroyed = this.onItemDestroyed.bind(this);
    this.onPanelContentClick = this.onPanelContentClick.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.onStackMax = this.onStackMax.bind(this);
    this.saveState = this.saveState.bind(this);
    this.switchLayout = this.switchLayout.bind(this);
    this.monitorPanelChange = this.monitorPanelChange.bind(this);
    this.delayedResize = this.delayedResize.bind(this);
    this.onCloseTabs = this.onCloseTabs.bind(this);
    this.onActionNavigate = this.onActionNavigate.bind(this);
    this.resizeContent = this.resizeContent.bind(this);
    this.updateComponentState = this.updateComponentState.bind(this);
  }

  closeStack(stack, checkDirty) {
    const { intl } = this.props;

    const remove = !checkDirty
      || !stackIsDirty(stack)
      || window.confirm(intl.formatMessage({ id: 'stack.close.warning' }));

    if (remove) {
      stack.remove();
      closeMultiplePanels(stack, this.props);
      this.configureSingleTabLayout();
    }
  }

  closeTab(component, checkDirty) {
    const { intl } = this.props;
    const remove = !checkDirty
      || !componentIsDirty(component)
      || window.confirm(intl.formatMessage({ id: 'tab.close.warning' }));

    if (remove) { this.closeTabandReIndex(component); }
  }

  // Golden Layout does not switch the activeItemIndex
  // This can cause issues when configuration is restored - so force index change
  // Never have 0 tabs, open home before proceeding with deleting final tab
  closeTabandReIndex(component) {
    if (this.componentCount() === 1) {
      this.findorCreatePanel(this.baseUrl);
    }
    closePanel(component, this.props);
    this.configureSingleTabLayout();
  }

  componentCount() {
    return this.allComponents().length;
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  componentDestroy(reactComponentHandler) {
    this.setState((state) => {
      const newRenderPanels = new Set(state.renderPanels);
      newRenderPanels.delete(reactComponentHandler);
      return { renderPanels: newRenderPanels };
    });
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  componentRender(reactComponentHandler) {
    this.setState((state) => {
      const newRenderPanels = new Set(state.renderPanels);
      newRenderPanels.add(reactComponentHandler);
      return { renderPanels: newRenderPanels };
    });
  }

  componentsByPosition(idePosition) {
    return this.allComponents()
      .filter((c) => c.config.componentState.idePosition === idePosition)
      .sort(comparePanels);
  }

  configureRefs() {
    this.layoutRef = React.createRef();
    this.wrapperRef = React.createRef();
    this.tabRef = React.createRef();
  }

  configureSingleTabLayout() {
    if (!this.oneTabOnly()) {
      this.toggleClosableTabAsync(this.componentCount() === 1).then();
    }
  }

  async customiseHeaders(components) {
    const items = components || this.allComponents();
    items.forEach((component) => customiseHeader(component, true));
  }

  developerLayout(oldLayout) {
    if (this.hasRootContentItem()) {
      this.unFocusLayout(this.ensureActiveStack(), oldLayout);
    }

    const panel = this.ensureActivePanel();
    const leftPanels = this.ensureComponentAtPosition('left', ['home']);
    const topRightPanels = this.ensureComponentAtPosition('top-right', ['datasets']);
    const bottomRightPanels = this.ensureComponentAtPosition('bottom-right', ['searches']);

    const config = {
      type: 'row',
      content: [{
        type: 'stack',
        width: 60,
        content: [],
      }, developerConfig(bottomRightPanels.length === 0)],
    };

    this.unhookTabState();

    this.allComponents().forEach((component) => {
      component.parent.removeChild(component, true);
    });

    this.layout.root.addChild(config);
    const stacks = this.allStacks();
    leftPanels.forEach((p) => stacks[0].addChild(p));
    topRightPanels.forEach((p) => stacks[1].addChild(p));
    bottomRightPanels.forEach((p) => stacks[2].addChild(p));

    this.monitorTabState();
    this.selectPanel(this.matchByTabUrl(panel));
    this.toggleClosableTabAsync(false).then();
    this.toggleClosableStackAsync().then();
    this.customiseHeaders().then();
  }

  ensureActivePanel() {
    const stack = this.ensureActiveStack();
    return stack ? stack.getActiveContentItem() : null;
  }

  ensureActiveStack() {
    const stack = this.activeStack();
    if (stack) { return stack; }

    this.selectStack(this.firstStack());
    return this.activeStack();
  }

  ensureComponentAtPosition(idePosition, defaultsIfNone) {
    const existing = this.componentsByPosition(idePosition);
    return existing.length > 0 ? existing : this.findAvailableDefault(defaultsIfNone);
  }

  findAvailableDefault(defaultsIfNone) {
    const tabs = [];
    const perms = this.permissions();
    const { currentUser } = this.authState();

    defaultsIfNone.forEach((value) => {
      const tab = findTabByUrl(value, perms, currentUser);

      if (tab.name !== 'notfound') {
        tabs.push(tabConfig(tab, value, this.props));
      }

      return tabs.length === 0;
    });

    return tabs;
  }

  findorCreatePanel(url) {
    const config = tabConfig(findTabByUrl(url), url, this.props);
    const panel = this.matchByTabUrl(config) || this.addChild(config);

    this.selectPanel(panel);
  }

  firstComponent() {
    return this.allComponents()[0];
  }

  firstStack() {
    const stacks = this.allStacks();
    return stacks ? stacks[0] : null;
  }

  focusLayout() {
    if (!this.hasRootContentItem()) { return; }

    this.toggleMax(this.ensureActiveStack(), true);
    this.toggleClosableTab(true);
  }

  hasRootContentItem() {
    return this.rootContentItem() !== undefined;
  }

  hookEvents() {
    this.saveLayoutOnChange();
    this.monitorSelectionChange();
    this.monitorTabState();
    this.monitorTabClick();
    this.monitorStackCreated();
    this.monitorTabCreated();
    window.addEventListener('resize', () => {
      this.resizeContent();
    });
  }

  layoutState() {
    const { store } = this.props;
    const { layout } = store.getState();

    return layout;
  }

  authState() {
    const { store } = this.props;
    const { auth } = store.getState();

    return auth;
  }

  permissions() {
    return this.authState().role.permissions;
  }

  listenTo() {
    listener.listenToToggleLabels(this.delayedResize);
    listener.listenToToggleRibbon(this.delayedResize);
    listener.listenToChangeLayout(this.switchLayout);
    listener.listenToCloseLayout(this.onCloseTabs);
    listener.listenToToggleAnnouncements(this.delayedResize);
    listener.listenToNavigate(this.onActionNavigate);
  }

  matchByTabUrl(tab) {
    const url = tab.config ? tab.config.componentState.url : tab.componentState.url;
    return this.matchByUrl(url);
  }

  matchByUrl(url) {
    const panel = this.ensureActivePanel();
    if (!panel) { return null; }
    const items = relativeUrls(url);

    if (includesComponent(panel, items)) {
      return panel;
    }

    return this.rootContentItem().getItemsByFilter((item) => includesComponent(item, items))[0];
  }

  monitorActiveContentItemChanged() {
    this.layout.on('activeContentItemChanged', this.onContainerShow);
  }

  updateComponentState(options, url) {
    const component = this.matchByUrl(url);

    if (component) {
      const { newKeys, newTitle } = checkTabChanges(component, options);
      newKeys.forEach((key) => {
        component.config.componentState[key] = options[key];
      });
      if (newTitle) {
        this.changeTitle(component, newTitle);
      }
    }
  }

  monitorPanelChange(options) {
    this.updateComponentState(options, options.url);
  }

  changeTitle(component, title) {
    if (title) {
      setTabTitle(component, title);
      this.applyFakeTabTitle(component);
    }
    this.configureSingleTabLayout();
    customiseHeader(component);
  }

  monitorSelectionChange() {
    this.layout.on('selectionChanged', this.onSelectionChanged);
  }

  monitorStackCreated() {
    this.layout.on('stackCreated', this.onStackCreated);
  }

  monitorTabClick() {
    const el = $(this.layoutRef.current);

    el.on('click', '.lm_active', (element) => { this.onTabClick(element).then(); });
    el.on('click', '.lm_stack:not(.lm_selected) .lm_item_container *', (element) => {
      this.onPanelContentClick(element).then();
    });
  }

  monitorTabClose() {
    this.layout.on('itemDestroyed', this.onItemDestroyed);
  }

  monitorTabCreated() {
    this.layout.on('tabCreated', this.onTabClose);
  }

  monitorTabState() {
    this.setState({ ignoreTabState: false });

    this.monitorActiveContentItemChanged();
    this.monitorTabClose();
  }

  navigateToComponent(component, byUrl) {
    const { overridingTabClick, activeUrl } = this.state;
    if (!overridingTabClick) {
      const { url } = component.config.componentState;

      this.selectStackAsync(component.parent).then();
      if (byUrl && url !== activeUrl) {
        this.navigateToUrl(url).then();
      }
    }
  }

  async navigateToUrl(url) {
    const { navigate } = this.props;
    this.setState({ overridingTabClick: true, activeUrl: url });

    navigate(url);
    this.setState({ overridingTabClick: false });
  }

  notifyChange() {
    this.notifyPanelChange(this.activePanel());
  }

  notifyPanelChange(panel) {
    const { switchActionsContext } = this.props;
    const container = panel || containerShell;
    const { config } = container;
    const { category, code, url } = config.componentState;

    this.applyFakeTabTitle(panel);

    switchActionsContext(config.component, category, code, url);
  }

  postRenderIDE() {
    this.configureSingleTabLayout();
    this.ensureActiveStack();
    this.saveStateAsync().then();
    this.customiseHeaders().then();
  }

  registerComponent() {
    this.layout.registerComponent('fair', (container) => {
      const { url } = container.glContainer._config.componentState;
      onTabAddIcon(container.glContainer);
      return (<WrappedTab url={url} onChange={this.monitorPanelChange} />);
    });
    this.layout.reactContainer = this;
    this.layout.init();
  }

  resizeContent() {
    this.layout.updateSize();
  }

  delayedResize() {
    for (let i = 5; i >= 1; i--) {
      setTimeout(this.resizeContent, i * 200);
    }
  }

  restoreLayout(renderFromLocal) {
    let content = this.savedState(renderFromLocal) || { url: relativeUrl(urls.HOME) };
    if (content.url) {
      content = defaultLayout(tabConfig(findTabByUrl(content.url), content.url, this.props));
    }

    this.layout = new GoldenLayout(layoutSettings(content), this.layoutRef.current);
  }

  rootContentItem() {
    return this.layout.root.contentItems[0];
  }

  saveLayoutOnChange() {
    this.layout.on('stateChanged', this.saveState);
  }

  saveState() {
    const { currentUser } = this.authState();
    if (!currentUser || currentUser.isGuest || this.oneTabOnly()) { return; }
    const components = this.allComponents();
    const key = layoutKey(currentUser.id);

    if (!components || components.length === 0) {
      localStorage.removeItem(key);
    } else if (components.length === 1) {
      localStorage.setItem(key, JSON.stringify({ url: components[0].config.componentState.url }));
    } else {
      localStorage.setItem(key, JSON.stringify({ content: this.layout.toConfig().content }));
    }
    if (components) {
      this.customiseHeaders(components).then();
    }
  }

  async saveStateAsync() {
    this.saveState();
  }

  savedState(restoreFromLocal) {
    const { currentUser } = this.authState();

    if (!restoreFromLocal || !currentUser || currentUser.isGuest) {
      return null;
    }

    const config = JSON.parse(localStorage.getItem(layoutKey(currentUser.id)));
    return transformLayout(config);
  }

  selectOnClose(component) {
    const stacks = this.allStacks();

    if (stacks.length > 1) {
      const { url } = component.config.componentState;
      let index = stacks.findIndex((stack) => stack.getItemsByFilter((item) => includesComponent(item, [url]))[0]) - 1;
      if (index < 0) { index = 1; }

      this.selectStack(stacks[index]);
    } else {
      this.notifyPanelChange();
    }
  }

  selectPanel(panel) {
    const currentStack = this.ensureActiveStack();
    const stack = panel.parent;

    this.selectStack(stack);
    if (currentStack && this.toggleMax(currentStack, false)) {
      this.toggleMax(stack, true);
    }

    if (stack.getActiveContentItem() !== panel) {
      stack.setActiveContentItem(panel);
    }
  }

  switchStack(currentStack, newStack) {
    const { layout } = this.layoutState();
    newStack.select();
    if (layout === 'focus') {
      currentStack.toggleMaximise();
      this.focusLayout();
    }
  }

  selectStack(stack) {
    const currentStack = this.activeStack();
    if (stack && currentStack !== stack) {
      this.switchStack(currentStack, stack);
    }
    this.notifyChange(stack);
  }

  async selectStackAsync(stack) {
    this.selectStack(stack);
  }

  stackCount() {
    const stacks = this.allStacks();
    return stacks ? stacks.length : 0;
  }

  switchLayout() {
    const { layout, oldLayout } = this.layoutState();

    switch (layout) {
      case 'tab':
        this.tabbedLayout(oldLayout);
        break;
      case 'focus':
        this.focusLayout();
        break;
      case 'ide':
        this.developerLayout(oldLayout);
        break;
      default:
        this.unFocusLayout(this.ensureActiveStack(), oldLayout);
        break;
    }
  }

  tabbedLayout(oldLayout) {
    const stack = this.ensureActiveStack();
    const doNothing = !stack || this.allStacks().length <= 1;

    if (stack) { this.unFocusLayout(stack, oldLayout); }
    if (doNothing) { return; }

    const panel = this.ensureActivePanel();
    const components = this.allComponents().filter((c) => c.parent !== stack).sort(comparePanels);

    this.unhookTabState();
    components.forEach((component) => {
      component.parent.removeChild(component, true);
      stack.addChild(component);
    });
    this.monitorTabState();

    this.selectPanel(panel);
    this.toggleClosableStackAsync().then();
    this.customiseHeaders().then();
  }

  async toggleClosableStackAsync() {
    this.toggleClosableStack();
  }

  toggleClosableStack() {
    const { fullscreen, layout } = this.layoutState();
    const el = $(this.layoutRef.current).find('.lm_header');

    if (fullscreen || layout === 'focus' || this.stackCount() === 1) {
      el.addClass('single_stack');
    } else {
      el.removeClass('single_stack');
    }
  }

  toggleClosableTab(show) {
    const tab = $(this.tabRef.current);
    const el = $(this.layoutRef.current).find('.lm_header');

    if (show) {
      this.applyFakeTabTitle(this.ensureActivePanel());
      el.removeClass('single_layout').addClass('focus_layout');
      tab.removeClass('single_layout').addClass('focus_layout');
    } else {
      el.removeClass('focus_layout');
      tab.removeClass('focus_layout');
    }
    this.toggleClosableStack();
  }

  async toggleClosableTabAsync(show) {
    this.toggleClosableTab(show);
  }

  toggleFullscreen(stack) {
    const { fullScreenToggle } = this.props;
    const { fullscreen, layout } = this.layoutState();
    const max = !fullscreen;

    fullScreenToggle();
    this.selectPanel(stack.getActiveContentItem());
    this.toggleMax(stack, max);

    const count = this.componentCount();
    const show = max || layout === 'focus' || count === 1;
    this.toggleClosableTabAsync(show).then();
  }

  toggleMax(stack, max) {
    const toggle = stack.isMaximised !== max;
    if (toggle) {
      const { layout } = this.layoutState();
      const skip = !max && layout === 'focus';
      if (!skip) { stack.toggleMaximise(); }

      this.delayedResize();
    }

    return toggle;
  }

  unFocusLayout(stack, oldLayout) {
    if (oldLayout === 'focus') {
      this.toggleMax(stack, false);
    }
    this.configureSingleTabLayout();
  }

  unhookTabState() {
    this.setState({ ignoreTabState: true });
    this.layout.off('itemDestroyed');
  }

  renderIDE(url, renderFromLocal) {
    this.restoreLayout(renderFromLocal);
    this.hookEvents();
    this.registerComponent();
    this.postRenderIDE();
    this.findorCreatePanel(url);
  }

  renderLayout() {
    const { location } = this.props;

    try {
      this.renderIDE(location.pathname, true);
    } catch (err) {
      this.renderIDE(location.pathname, false);
    }
  }

  render() {
    const { renderPanels } = this.state;
    const panels = Array.from(renderPanels || []);

    return (
      <div className="tab-wrapper aridhia-layout-manager" ref={this.wrapperRef}>
        <ToastContainer transition={Slide} />
        <div className="faux_tab" ref={this.tabRef}>
          <TabsDropDown />
        </div>
        <div className="app-tabContent tab-content" ref={this.layoutRef}>
          {panels.map((panel) => ReactDOM.createPortal(
            panel._getReactComponent(),
            panel._container.getElement()[0],
          ))}
        </div>
      </div>
    );
  }
}

GoldenLayout.__lm.utils.ReactComponentHandler = ReactComponentHandlerPatched;

const mapDispatchToProps = {
  switchActionsContext: updateActions,
  applyTabsToDropDown: updateTabs,
  changeTitle: updateTitle,
  fullScreenToggle: updateFullscreen,
  search: ({ query }) => decodeSearchQuery('open', null, query),
  ...Object.assign({}, ...Panels.map(({ close }) => close.action)),
};

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(LayoutManager)));
